// Countries for customers and suppliers. The country decides VAT treatment
// (Ireland, the rest of the EU, Northern Ireland/UK, or outside), so the EU is
// listed as a group. Each country's usual currency is suggested for a new contact.

export interface Country { code: string; name: string; currency: string }

const k = (code: string, name: string, currency: string): Country => ({ code, name, currency });

export const EU: Country[] = [
  k('IE', 'Ireland', 'EUR'), k('AT', 'Austria', 'EUR'), k('BE', 'Belgium', 'EUR'), k('BG', 'Bulgaria', 'EUR'), k('HR', 'Croatia', 'EUR'),
  k('CY', 'Cyprus', 'EUR'), k('CZ', 'Czechia', 'CZK'), k('DK', 'Denmark', 'DKK'), k('EE', 'Estonia', 'EUR'), k('FI', 'Finland', 'EUR'),
  k('FR', 'France', 'EUR'), k('DE', 'Germany', 'EUR'), k('GR', 'Greece', 'EUR'), k('HU', 'Hungary', 'HUF'), k('IT', 'Italy', 'EUR'),
  k('LV', 'Latvia', 'EUR'), k('LT', 'Lithuania', 'EUR'), k('LU', 'Luxembourg', 'EUR'), k('MT', 'Malta', 'EUR'), k('NL', 'Netherlands', 'EUR'),
  k('PL', 'Poland', 'PLN'), k('PT', 'Portugal', 'EUR'), k('RO', 'Romania', 'RON'), k('SK', 'Slovakia', 'EUR'), k('SI', 'Slovenia', 'EUR'),
  k('ES', 'Spain', 'EUR'), k('SE', 'Sweden', 'SEK'),
];

export const REST_OF_EUROPE: Country[] = [
  k('GB', 'United Kingdom', 'GBP'), k('CH', 'Switzerland', 'CHF'), k('NO', 'Norway', 'NOK'), k('IS', 'Iceland', 'ISK'),
  k('LI', 'Liechtenstein', 'CHF'), k('TR', 'Türkiye', 'TRY'), k('RS', 'Serbia', 'RSD'), k('UA', 'Ukraine', 'UAH'),
  k('BA', 'Bosnia and Herzegovina', 'BAM'), k('ME', 'Montenegro', 'EUR'), k('MK', 'North Macedonia', 'MKD'), k('AL', 'Albania', 'ALL'),
  k('MD', 'Moldova', 'MDL'), k('GE', 'Georgia', 'GEL'),
];

export const REST_OF_WORLD: Country[] = [
  k('US', 'United States', 'USD'), k('CA', 'Canada', 'CAD'), k('MX', 'Mexico', 'MXN'), k('BR', 'Brazil', 'BRL'), k('AR', 'Argentina', 'ARS'),
  k('CL', 'Chile', 'CLP'), k('CO', 'Colombia', 'COP'),
  k('CN', 'China', 'CNY'), k('HK', 'Hong Kong', 'HKD'), k('TW', 'Taiwan', 'TWD'), k('JP', 'Japan', 'JPY'), k('KR', 'South Korea', 'KRW'),
  k('SG', 'Singapore', 'SGD'), k('IN', 'India', 'INR'), k('VN', 'Vietnam', 'VND'), k('TH', 'Thailand', 'THB'), k('MY', 'Malaysia', 'MYR'),
  k('ID', 'Indonesia', 'IDR'), k('PH', 'Philippines', 'PHP'), k('BD', 'Bangladesh', 'BDT'), k('PK', 'Pakistan', 'PKR'),
  k('AU', 'Australia', 'AUD'), k('NZ', 'New Zealand', 'NZD'),
  k('AE', 'United Arab Emirates', 'AED'), k('SA', 'Saudi Arabia', 'SAR'), k('IL', 'Israel', 'ILS'), k('EG', 'Egypt', 'EGP'),
  k('MA', 'Morocco', 'MAD'), k('ZA', 'South Africa', 'ZAR'),
];

const byName = (a: Country, b: Country) => a.name.localeCompare(b.name);

export const COUNTRY_GROUPS: { label: string; countries: Country[] }[] = [
  { label: 'European Union', countries: [EU[0]!, ...EU.slice(1).sort(byName)] },
  { label: 'Rest of Europe', countries: [...REST_OF_EUROPE].sort(byName) },
  { label: 'Rest of the world', countries: [...REST_OF_WORLD].sort(byName) },
];

export const COUNTRIES: Country[] = [...EU, ...REST_OF_EUROPE, ...REST_OF_WORLD];
export const countryCurrency = (code: string) => COUNTRIES.find((c) => c.code === code)?.currency;
